import { render, staticRenderFns } from "./ParkCard.vue?vue&type=template&id=65506e84&scoped=true&"
import script from "./ParkCard.vue?vue&type=script&lang=js&"
export * from "./ParkCard.vue?vue&type=script&lang=js&"
import style0 from "./ParkCard.vue?vue&type=style&index=0&id=65506e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65506e84",
  null
  
)

export default component.exports